import { ClassifierToken, SlippageTier, tokenTier } from './classifier';

/** Tier -> bps (data-backed launch values). */
const TIER_BPS: Record<SlippageTier, number> = {
  stable: 8,
  major: 50,
  mid: 100,
  longtail: 200,
  volatile: 300,
  emerging: 800,
  nascent: 1000,
};

/**
 * Cross-chain fills settle over minutes, so tolerances below 50 bps add failure risk
 * without meaningful price protection. Stable-to-stable routes still use this floor.
 */
export const CROSS_CHAIN_MIN_AUTO_SLIPPAGE_BPS = 50;

export type AutoSlippageLeg = {
  token: ClassifierToken | undefined | null;
  chainId: number;
};

/** Auto slippage is the riskier leg's tier value, subject to the route's floor. */
export const getLegsAutoSlippageBps = (
  legs: ReadonlyArray<AutoSlippageLeg>,
  floorBps = 0,
): number =>
  Math.max(floorBps, ...legs.map(({ token, chainId }) => TIER_BPS[tokenTier(token, chainId)]));

/** Cross-chain Auto slippage is the riskier leg's tier value with a 50 bps floor. */
export const getCrossChainAutoSlippageBps = (
  sellToken: ClassifierToken | undefined | null,
  sellChainId: number,
  buyToken: ClassifierToken | undefined | null,
  buyChainId: number,
): number =>
  getLegsAutoSlippageBps(
    [
      { token: sellToken, chainId: sellChainId },
      { token: buyToken, chainId: buyChainId },
    ],
    CROSS_CHAIN_MIN_AUTO_SLIPPAGE_BPS,
  );
